export default function promiseFromEvent<T extends keyof HTMLElementEventMap>(
    target: EventTarget,
    eventName: T
): Promise<HTMLElementEventMap[T]> {
    return new Promise<HTMLElementEventMap[T]>(resolve => {
        const handler = (ev: Event) => {
            resolve(ev as HTMLElementEventMap[T]);
            target.removeEventListener(eventName, handler);
        };
        target.addEventListener(eventName, handler);
    });
}
